import Route from '@ember/routing/route';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class PslfEmployerRoute extends Route {
  @service declare router: RouterService;

  queryParams = {
    approval: { refreshModel: true, replace: true },
  };

  model(params: { form_document_id: string }) {
    const { form_document_id } = params;
    // form_document_id is an opaque path segment: the form id on partner links, an encoded
    // approval token on non-partner links (previously a SignNow-era document_id). It's only
    // echoed into redirect URLs — all backend lookups happen via the `approval` query param.
    return {
      pathToken: form_document_id,
    };
  }

  afterModel() {
    this.router.transitionTo('pslf-employer.non-partner-sign');
  }
}
